import { useEffect, useMemo } from 'react';
import throttle from 'lodash/throttle';

const useThrottledCallback = <T extends (...args: any[]) => any>(callback: T, wait = 300) => {
  const throttledCallback = useMemo(() => throttle(callback, wait, { trailing: false }), [callback, wait]);

  useEffect(() => () => throttledCallback.cancel(), [throttledCallback]);

  return throttledCallback;
};

export default useThrottledCallback;
